import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { shadows } from "../../../theme/theme";

export const StyledCardWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["clickable", "bigB"].includes(prop),
})(({ theme, clickable, bigB }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  minHeight: bigB ? "200px" : "150px",
  padding: theme.spacing(2, 3),
  backgroundColor: "#fff",
  borderRadius: "30px",
  boxShadow: shadows.card,
  cursor: clickable ? "pointer" : "default",
  position: "relative",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  height: "100%",
  ...(clickable && {
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: shadows.cardHover,
    },
  }),
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: "'Gotham', sans-serif",
  fontWeight: 500,
  fontSize: "22px",
  maxWidth: "85%",
  letterSpacing: "0.2px",
  [theme.breakpoints.down("md")]: {
    fontSize: "18px",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.spacing(2),
  },
}));

export const StyledIconBox = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export const iconSx = {
  fontSize: "24px",
  color: "#29405A",
};

export const spinnerSx = {
  color: "#29405A",
};
